import React, { useState, useEffect } from 'react';

const MandatoryAd = ({ onClose, adData, adType }) => {
  const [timeLeft, setTimeLeft] = useState(10);
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    if (adType === 'video' && timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0) {
      setCanClose(true);
    }
  }, [timeLeft, adType]);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.9)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
        borderRadius: '20px',
        padding: '30px',
        maxWidth: '500px',
        width: '90%',
        textAlign: 'center'
      }}>
        <h3 style={{ color: '#00E9FF', marginBottom: '20px' }}>
          {adType === 'video' ? '📹 Video Ad' : '🌐 Sponsored Content'}
        </h3>
        
        {adType === 'video' ? (
          <div>
            <div style={{
              background: '#000',
              borderRadius: '10px',
              marginBottom: '15px',
              minHeight: '200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {adData?.content ? (
                <video
                  width="100%"
                  height="200"
                  controls
                  autoPlay
                  style={{ borderRadius: '10px' }}
                 >
                  <source src={adData.content} type="video/mp4" />
                  Your browser does not support the video tag.
                </video> 
               ) : (
              <p style={{ color: 'white' }}>Video loading...</p>
            )}
            </div>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              {timeLeft > 0 ? `Please wait ${timeLeft} seconds...` : 'You can now close this ad'}
            </p>
          </div>
        ) : (
          <div>
            <p style={{ color: 'white', marginBottom: '20px' }}>{adData?.description}</p>
            <button
              onClick={() => {
                window.open(adData?.content, '_blank');
                setCanClose(true); // Allow closing after visiting
              }}
              style={{
                backgroundColor: '#00E9FF',
                color: '#000',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                cursor: 'pointer',
                marginBottom: '15px',
                fontWeight: 'bold'
              }}
            >
              Visit Website
            </button>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '14px' }}>
              You must visit the website to continue
            </p>
          </div>
        )}

        <button
          onClick={onClose}
          disabled={(adType === 'video' && !canClose) || (adType === 'website' && !canClose)}
          style={{
            backgroundColor: canClose ? '#28a745' : '#6c757d',  
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: canClose ? 'pointer' : 'not-allowed',
            marginTop: '15px'
          }}
        >
        {!canClose ? (adType === 'video' ? `Wait ${timeLeft}s` : 'Visit Website First') : 'Continue to App'}
      </button>
    </div>
  </div>
);
};
export default MandatoryAd;